import { useLocation, useNavigate, useParams } from "react-router-dom";

export const useLanguageSwitch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();

  const switchLanguage = (newLang: string) => {
    if (!lang) return;

    const newPath = location.pathname.replace(`/${lang}`, `/${newLang}`);

    localStorage.setItem("i18nextLng", newLang);

    navigate(newPath + location.search);
  };

  return { switchLanguage };
};
